import { PaymentMethods } from 'types/beneficiaries'

export const ERROR_MESSAGES = {
  INVALID_BENEFICIARY_NAME_MESSAGE: 'invalid beneficiary name',
  INVALID_INTERMEDIARY_BANK_MESSAGE: 'invalid intermediary bank details',
}

export const IBAN_VALIDATION_ERRORS = {
  COUNTRY_DOES_NOT_SUPPORT_IBAN: 'Country does not support IBAN standard',
} as const

export const PaymentMethodStatusColourMapping = {
  [PaymentMethods.ACH]: 'success',
  [PaymentMethods.CUBIX]: 'feature',
  [PaymentMethods.FEDWIRE]: 'neutral',
} as const
